var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatTaken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.8 44",
    style: {
      enableBackground: "new 0 0 50.8 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CDD5E8;stroke:#FFFFFF;stroke-width:0.643;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FCFCFF;}\r\n\t.st3{fill:#CDD5E8;stroke:#FFFFFF;stroke-width:0.8457;stroke-miterlimit:10;}\r\n\t.st4{fill:#455572;stroke:#F8FAFF;stroke-width:0.6432;stroke-miterlimit:10;}\r\n\t.st5{fill:#455572;}\r\n\t.st6{fill:#F8FAFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375_00000076582427347312084890000012294912419940005045_",
    className: "st0",
    d: "M39.9,32.9h-29c-3.2,0-5.8-2.6-5.8-5.8 c0,0,0,0,0,0V6.2c0-3.2,2.6-5.8,5.8-5.8c0,0,0,0,0,0h29c3.2,0,5.8,2.6,5.8,5.8c0,0,0,0,0,0v21C45.6,30.3,43,32.9,39.9,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,33.3C39.9,33.3,39.9,33.3,39.9,33.3h-29c0,0,0,0,0,0c-3.4,0-6.2-2.8-6.2-6.2V6.2c0-1.7,0.6-3.2,1.8-4.4 C7.7,0.6,9.2,0,10.9,0h29c0,0,0,0,0,0c3.4,0,6.2,2.8,6.2,6.2v21C46,30.5,43.3,33.3,39.9,33.3z M10.9,32.4h29c0,0,0,0,0,0 c2.9,0,5.3-2.4,5.3-5.3v-21c0-3-2.4-5.3-5.3-5.3c0,0,0,0,0,0h-29c-3,0-5.3,2.4-5.3,5.3v20.9C5.6,30,8,32.4,10.9,32.4 C10.9,32.4,10.9,32.4,10.9,32.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376_00000033341202134942175040000005337712667152371089_",
    className: "st0",
    d: "M6.3,33.3H2.8c-1.2,0-2.3-1-2.3-2.2 V14.4c0-1.2,1-2.3,2.2-2.3h3.7c1.2,0,2.3,1,2.3,2.2V31c0.1,1.2-0.8,2.2-1.9,2.3H6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.3,33.7H2.8c-1.5,0-2.7-1.2-2.8-2.6V14.4c0-1.5,1.2-2.7,2.6-2.8h3.7c1.5,0,2.7,1.2,2.8,2.6V31 c0.1,1.4-0.9,2.6-2.3,2.8L6.3,33.7z M2.7,12.5c-1,0-1.8,0.9-1.8,1.9v16.7c0,1,0.9,1.8,1.9,1.8h4C7.6,32.8,8.3,32,8.2,31l0-16.8 c0-1-0.9-1.8-1.9-1.8H2.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377_00000047052365708854576760000012316514262010091679_",
    className: "st0",
    d: "M48,33.3h-3.6c-1.2,0-2.3-1-2.3-2.2 V14.4c0-1.2,1-2.3,2.2-2.3H48c1.2,0,2.3,1,2.3,2.2V31C50.4,32.3,49.3,33.3,48,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,33.7h-3.6c-1.5,0-2.7-1.2-2.8-2.6V14.4c0-1.5,1.2-2.7,2.6-2.8H48c1.5,0,2.7,1.2,2.8,2.6V31 C50.8,32.5,49.5,33.7,48,33.7L48,33.7z M44.4,12.5c-1,0-1.8,0.9-1.8,1.9v16.7c0,1,0.9,1.8,1.9,1.8H48c1,0,1.9-0.9,1.9-1.9V14.3 c0-1-0.9-1.8-1.9-1.8H44.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378_00000158004391240022590250000010959496069385799318_",
    className: "st0",
    d: "M9.2,32.7h32.1c2.3,0,4.1,1.9,4.2,4.2 l0,0c0,3.7-3,6.7-6.7,6.7H12c-3.7,0-6.7-3-6.7-6.7l0,0c-0.1-2.1,1.5-4,3.6-4.2H9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,43.9c-3.9,0-7.1-3.2-7.1-7.1c-0.1-2.4,1.7-4.4,4-4.6l0.2,0h32.1c2.5,0.1,4.5,2.1,4.6,4.6 c0,3.9-3.2,7.1-7.1,7.1H12z M9,33.1c-1.9,0.2-3.3,1.8-3.2,3.7c0,3.4,2.8,6.2,6.3,6.3h26.7c3.4,0,6.2-2.8,6.3-6.3 c0-2-1.7-3.7-3.7-3.7H9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    className: "st3",
    d: "M135.3,39.2h-29c-3.1,0-5.7-2.5-5.8-5.6c0,0,0,0,0,0V13.3c0-3.1,2.6-5.7,5.8-5.6 c0,0,0,0,0,0h29c3.1,0,5.7,2.5,5.8,5.6c0,0,0,0,0,0v20.4C141,36.8,138.4,39.2,135.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    className: "st3",
    d: "M101.1,40.4h-3.4c-1.2,0-2.2-1-2.3-2.2V21.3c0-1.2,0.9-2.3,2.2-2.3h3.6c1.2,0,2.2,1,2.3,2.2 V38c0.1,1.2-0.7,2.2-1.9,2.3H101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    className: "st3",
    d: "M144.8,40.4h-3.4c-1.2,0-2.2-1-2.3-2.2V21.3c0-1.2,0.9-2.3,2.2-2.3h3.6c1.2,0,2.2,1,2.3,2.2 V38C147.1,39.3,146.1,40.3,144.8,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    className: "st3",
    d: "M104.6,39.9h32.1c2.2,0,4.1,1.8,4.2,4l0,0c-0.1,3.6-3.1,6.5-6.7,6.5h-26.7 c-3.6,0-6.6-2.9-6.7-6.5l0,0c-0.1-2.1,1.5-3.9,3.6-4H104.6z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14652",
    transform: "translate(1.573 1.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46030",
    className: "st4",
    d: "M104,20.8h-8.2c0-1.8,1.5-3.2,3.3-3.3h1.7C102.6,17.5,104,19,104,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46031",
    className: "st4",
    d: "M142.9,20.8h-8.2c0-1.8,1.5-3.2,3.3-3.3h1.7C141.4,17.5,142.8,18.9,142.9,20.8 C142.9,20.7,142.9,20.7,142.9,20.8L142.9,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46032",
    className: "st4",
    d: "M134.5,21.1v7.1c-1.5,0-2.7-1.2-2.7-2.6c0,0,0,0,0,0V14c0-2.9-2.2-5.4-5-5.7 c-3.1-0.3-5.8,1.9-6.1,5c0,0.1,0,0.3,0,0.5v7.1h-1.5v-6.9c0-2.9-2.2-5.4-5-5.7c-3.1-0.3-5.8,1.9-6.1,5c0,0.1,0,0.3,0,0.5v11.9 c0,1.5-1.2,2.7-2.7,2.7c0,0,0,0,0,0h-0.9v-7.1h-8.4v11.7c0,4.6,3.8,8.2,8.3,8.2c0,0,0,0,0,0h30.3c4.6,0.1,8.3-3.6,8.4-8.1 c0,0,0,0,0,0V21.1H134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46033",
    className: "st4",
    d: "M119.4,46.3L119.4,46.3c-4.7,0-8.5-3.8-8.5-8.5c0,0,0,0,0,0v-3.3c0-4.7,3.8-8.5,8.5-8.5 l0,0c4.7,0,8.5,3.8,8.5,8.5v3.3C127.8,42.5,124,46.3,119.4,46.3C119.4,46.3,119.4,46.3,119.4,46.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14652_00000041264722663251811250000001656631815170784902_",
    transform: "translate(1.573 1.481)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46030_00000080915434997021813430000006484289965085310351_",
    className: "st5",
    d: "M8.7,13.7H0.3 c0-1.8,1.5-3.2,3.3-3.3h1.7C7.2,10.5,8.7,11.9,8.7,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9,14H0l0-0.3c0-2,1.7-3.6,3.6-3.6h1.7c2,0,3.6,1.6,3.6,3.6L9,14z M0.7,13.4h7.7c-0.2-1.5-1.4-2.6-3-2.6H3.7 C2.1,10.8,0.9,11.9,0.7,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46031_00000100352390440123998460000015686062627510616199_",
    className: "st5",
    d: "M47.3,13.7H39 c0-1.8,1.5-3.2,3.3-3.3H44C45.8,10.4,47.3,11.9,47.3,13.7C47.3,13.7,47.3,13.7,47.3,13.7L47.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47.3,14h-8.7l0-0.3c0-2,1.7-3.6,3.6-3.6H44c1,0,1.9,0.3,2.6,1c0.7,0.7,1.1,1.5,1.1,2.5l0,0.3L47.3,14z  M39.3,13.4H47c-0.1-0.7-0.4-1.3-0.9-1.8c-0.6-0.5-1.3-0.8-2.1-0.8h-1.7C40.8,10.8,39.5,11.9,39.3,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46032_00000096747296727565030860000015492487856398620582_",
    className: "st5",
    d: "M39,14.1v7.1 c-1.5,0-2.7-1.2-2.7-2.6c0,0,0,0,0,0V6.9c0-2.9-2.2-5.4-5-5.7c-3.1-0.3-5.8,1.9-6.1,5c0,0.1,0,0.3,0,0.5v7.1h-1.5V6.8 c0-2.9-2.2-5.4-5-5.7c-3.1-0.3-5.8,1.9-6.1,5c0,0.1,0,0.3,0,0.5v11.9c0,1.5-1.2,2.7-2.7,2.7c0,0,0,0,0,0H8.7V14H0.3v11.7 c0,4.6,3.8,8.2,8.3,8.2c0,0,0,0,0,0H39c4.6,0.1,8.3-3.6,8.4-8.1c0,0,0,0,0,0V14.1L39,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.1,34.2c0,0-0.1,0-0.1,0H8.7c0,0-0.1,0-0.1,0c-2.3,0-4.4-0.9-6-2.5C0.9,30.2,0,28,0,25.7v-12h9v7.1h0.6 c0,0,0,0,0,0c1.3,0,2.4-1,2.4-2.3V6.5c0-0.2,0-0.3,0-0.5c0.3-3.2,3.2-5.6,6.5-5.3c3.1,0.4,5.4,3,5.3,6v6.6h0.9V6.6 c0-0.2,0-0.3,0-0.5c0.2-1.6,0.9-3,2.2-4s2.8-1.5,4.3-1.3c3.1,0.4,5.4,3,5.3,6v11.6c0,1.2,0.9,2.2,2.1,2.3v-7.1h9v11.9 C47.6,30.5,43.7,34.2,39.1,34.2z M39,33.6c0,0,0.1,0,0.1,0c4.3,0,7.9-3.5,7.9-7.8V14.4h-7.7v7.1l-0.3,0c0,0,0,0,0,0 c-1.6,0-3-1.3-3-3V6.9c0-2.8-2-5.1-4.8-5.4c-1.4-0.1-2.8,0.3-3.9,1.1s-1.8,2.1-1.9,3.5c0,0.1,0,0.3,0,0.4V14h-2.2V6.8 c0-2.8-2-5.1-4.8-5.4c-2.9-0.3-5.5,1.8-5.8,4.7c0,0.1,0,0.3,0,0.4l0,11.9c0,1.7-1.4,3-3,3H8.4v-7.1H0.7v11.4 c0,2.1,0.9,4.1,2.4,5.6c1.5,1.5,3.5,2.3,5.6,2.3H39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46033_00000136398960396254468740000014218119519121505454_",
    className: "st5",
    d: "M23.8,39.2L23.8,39.2 c-4.7,0-8.5-3.8-8.5-8.5c0,0,0,0,0,0v-3.3c0-4.7,3.8-8.5,8.5-8.5l0,0c4.7,0,8.5,3.8,8.5,8.5v3.3C32.3,35.4,28.5,39.2,23.8,39.2 C23.8,39.2,23.8,39.2,23.8,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.8,39.6L23.8,39.6c-4.9,0-8.8-3.9-8.8-8.8v-3.4c0-4.8,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8v3.3 c0,2.3-0.9,4.6-2.6,6.2C28.4,38.6,26.2,39.6,23.8,39.6z M23.8,19.3c-4.5,0-8.2,3.7-8.2,8.2v3.3c0,4.5,3.7,8.2,8.2,8.2 c2.2,0,4.2-0.8,5.8-2.4c1.5-1.5,2.4-3.6,2.4-5.8v-3.3C32,22.9,28.3,19.3,23.8,19.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatTaken);
export default __webpack_public_path__ + "static/media/seat_taken.6fd38fddcf3b41b89cc457faa7a45c74.svg";
export { ForwardRef as ReactComponent };